import React from 'react';

// Context
import { useAuth } from '../../../../context/auth';

 
export default function CartaoFicha({ titulo, children, className = "" }) {
    const { logoSistema, logoSecretaria, logoPrefeitura } = useAuth();

    return (
        <div className={`bg-white rounded shadowFicha mainContainerFicha p-3 ${className}`}>
            <div className="d-flex justify-content-between align-items-center w-100">
                {logoSistema && (
                    <div>
                        <img src={logoSistema} width={180} alt="logo do sistema" />
                    </div>
                )}
                {logoSecretaria && (
                    <div>
                        <img src={logoSecretaria} className="mt-3" width={140} alt="logo do sistema" />
                        <img src={logoPrefeitura} width={120} alt="logo da prefeitura" />
                    </div>
                )}
            </div>
            <h2 className="titleFicha m-0">{titulo}</h2>
            {children}
        </div>
    );
}
